/* Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. */

import { AngularFireAction, DatabaseSnapshot } from '@angular/fire/compat/database';

import { FancyFirebaseSplitDataList } from '../generics/FancyFirebaseSplitDataList';
import { DefaultSplitDataRenderType } from '@touchplan/common';
import { IOrganizationMemberFields, OrganizationMember } from 'src/app/app-data/models/OrganizationMember';
import { AngularLandConnection, RefOrObservable } from '../base/interfaces';
import { IFancyIdJoin } from '../base/FancyIdJoin';

export class OrganizationMemberList
	extends FancyFirebaseSplitDataList<
		IOrganizationMemberFields,
		DefaultSplitDataRenderType,
		OrganizationMember
	>
	implements IFancyIdJoin
{
	constructor(angularLand: AngularLandConnection, path: RefOrObservable, fancyJoins?: any) {
		//fix any's
		super(angularLand, path, fancyJoins);
	}

	public $$added(action: AngularFireAction<DatabaseSnapshot<any>>) {
		const organizationMember = new OrganizationMember(action.payload.key);
		organizationMember.databaseUpdate(action.payload.val());
		return organizationMember;
	}

	public $$updated(child: OrganizationMember, action: AngularFireAction<DatabaseSnapshot<any>>) {
		super.$$updated(child, action);
	}

	public applyJoinData(baseKey: string, child: OrganizationMember, otherChild: any) {
		switch (baseKey) {
			case 'organizationId':
				child.view.organization = otherChild ? otherChild : null;
				break;
			case 'userId':
				child.view.user = otherChild ? otherChild : null;
				break;
			default:
				break;
		}
	}

	public getDataForKey(baseKey: string, child: OrganizationMember) {
		return child.view[baseKey];
	}
}
